 
import React   from 'react' ;
 import PageCh20_t1 from './PageCh20_t1';
 import PageCh20_t2 from './PageCh20_t2';
const   PageCh20 = ()=>{
  
   
    return (
      <>  <hr/> 
      <h1 className="m-2" >Chapter20 - Building a Multi-Page SPA with React Router </h1>
        
        <PageCh20_t1 />   
        
      </>
    )
     
} 
export default PageCh20
